import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { combineLatestWith, filter, first, Observable, ReplaySubject, skip, Subject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { DeliveryType } from '../../api/v1/models/delivery-type';
import { SessionRepository } from '../../shared/repositories/session.repository';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class OrderDeliveryModalService {
  private sessionRepository = inject(SessionRepository);
  private platformId = inject(PLATFORM_ID);

  private isCheckOrderTypeModal: boolean = false;

  constructor() {
    if(!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.sessionRepository.basketItems$.pipe(
      skip(1),
      filter(items => !!items.length),
      first(),
    ).subscribe(() => {
      if(this.isCheckOrderTypeModal) {
        return;
      }

      this.isCheckOrderTypeModal = true;
      setTimeout(() => {
        this.checkOrderTypeModal();
      }, 250);
    });
  }

  private _isShowOrderTypeModalSubj$: Subject<boolean> = new Subject<boolean>();

  get isShowOrderTypeModal$(): Observable<boolean> {
    return this._isShowOrderTypeModalSubj$.asObservable();
  }

  setOrderTypeModalState(state: boolean): void {
    this._isShowOrderTypeModalSubj$.next(state);
  }

  private _checkOrderTypeModalSubj$: ReplaySubject<unknown> = new ReplaySubject<unknown>(1);

  get checkOrderTypeModal$(): Observable<unknown> {
    return this._checkOrderTypeModalSubj$.asObservable();
  }

  checkOrderTypeModal(): void {
    this.subscribeToCheckOrderTypeModal();
    this._checkOrderTypeModalSubj$.next(null);
  }

  private checkSubscribe: Subscription;

  private subscribeToCheckOrderTypeModal(): void {
    this.checkSubscribe = this.isCheckOrderTypeModal$.pipe(
      first()
    ).subscribe(isShow => {
      if(isShow) {
        this.setOrderTypeModalState(true);
      }
      this.checkSubscribe.unsubscribe();
    });
  }

  isCheckOrderTypeModal$: Observable<boolean> = this.checkOrderTypeModal$.pipe(
    combineLatestWith(
      this.sessionRepository.selectedDeliveryType$,
      this.sessionRepository.deliveryAddress$,
    ),
    map(([_, selectedDeliveryType, deliveryAddress]) => {
      if(selectedDeliveryType === DeliveryType.Pickup || selectedDeliveryType === DeliveryType.Eatin) {
        return false;
      }

      if(selectedDeliveryType === DeliveryType.Delivery && deliveryAddress) {
        return false;
      }
      return true;
    })
  );
}
